<template>
  <div id="scrollId" class="con4">
    <div class="con4_title">{{ title }}</div>
    <div class="con4_box">
      <div
        :class="['box_list', `box_move_${status}_${index + 1}`, ` box_${status}`]"
        v-for="(img, index) in imgs"
        :key="index"
        :style="{ 'background-image': `url(${img})` }"
      ></div>
      <div class="con4_con" @click="jump" :style="{ backgroundImage: `url(${centerImg})` }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    imgs: Array,
    url: String,
    centerImg: String,
  },
  data() {
    return {
      isInview: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    scrollHandle() {
      // 部分浏览器document.documentElement.scrollTop会一直是0, 所以再从body上取一次值
      const scrollTop1 = (document.documentElement && document.documentElement.scrollTop) || 0
      const scrollTop2 = document.body.scrollTop || 0
      const scrollTop = scrollTop1 || scrollTop2 // 滚动条偏移量
      const ele = document.querySelector('#scrollId')
      if (!ele) return
      const { offsetTop } = ele // 要滚动到顶部吸附的元素的偏移量
      this.isInview = offsetTop + 900 >= scrollTop && offsetTop + 900 < scrollTop + window.screen.availHeight
    },
    jump() {
      window.open(this.url)
    },
  },
  computed: {
    status() {
      return this.isInview ? 'on' : 'off'
    },
  },
}
</script>

<style lang="less" scoped>
.con4 {
  width: 100%;
  height: 770px;
  background: #f8f8f8;
}

.con4 .con4_title {
  font-size: 36px;
  color: #333;
  padding-top: 70px;
  display: flex;
  justify-content: center;
}

.con4_con {
  position: absolute;
  width: 1200px;
  height: 600px;
  cursor: pointer;
  left: 0;
  background-size: 454px 454px;
  background-position: 50%;
  background-repeat: no-repeat;
  right: 0;
  margin: auto;
}

.con4 .con4_box {
  width: 1200px;
  height: 600px;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;

  .box_list {
    position: absolute;
    height: 72px;
    box-shadow: 2px 2px 19px 0 #f2f2f2;
    border-radius: 42px;
    background-size: cover;
    background-repeat: no-repeat;
    width: 320px;
    transition: transform 1s;
  }

  .box_on {
    transform: scaleX(1);
  }

  .box_off {
    transform: scaleX(0);
  }

  .box_move_on_1 {
    animation: boxOn1 1s forwards, boxJump1 1.7s infinite 1s ease-in-out;
  }

  .box_move_off_1 {
    animation: boxOff1 1s;
  }

  .box_move_on_2 {
    animation: boxOn 1s forwards, boxOn2 1s forwards, boxJump2 1.75s infinite 1s ease-in-out;
  }

  .box_move_off_2 {
    animation: boxOff 1s forwards, boxOff2 1s forwards;
  }

  .box_move_on_3 {
    animation: boxOn 1s forwards, boxOn3 1s forwards, boxJump3 1.8s infinite 1s ease-in-out;
  }

  .box_move_off_3 {
    animation: boxOff 1s forwards, boxOff3 1s forwards;
  }

  .box_move_on_4 {
    animation: boxOn 1s forwards, boxOn4 1s forwards, boxJump4 2s infinite 1s ease-in-out;
  }

  .box_move_off_4 {
    animation: boxOff 1s forwards, boxOff4 1s forwards;
  }

  .box_move_on_5 {
    animation: boxOn 1s forwards, boxOn5 1s forwards, boxJump5 1.9s infinite 1s ease-in-out;
  }

  .box_move_off_5 {
    animation: boxOff 1s forwards, boxOff5 1s forwards;
  }

  .box_move_on_6 {
    animation: boxOn 1s forwards, boxOn6 1s forwards, boxJump6 1.85s infinite 1s ease-in-out;
  }

  .box_move_off_6 {
    animation: boxOff 1s forwards, boxOff6 1s forwards;
  }
}

@keyframes boxOn1 {
  from {
    left: 550px;
    margin-top: 300px;
  }

  to {
    left: 0;
    margin-top: 80px;
  }
}

@keyframes boxOff1 {
  from {
    left: 0;
    margin-top: 80px;
  }

  to {
    left: 550px;
    margin-top: 300px;
  }
}

@keyframes boxOn2 {
  from {
    left: 550px;
    margin-top: 300px;
  }

  to {
    left: 51px;
    margin-top: 280px;
  }
}

@keyframes boxOff2 {
  from {
    left: 51px;
    margin-top: 280px;
  }

  to {
    left: 550px;
    margin-top: 300px;
  }
}

@keyframes boxOn3 {
  from {
    left: 550px;
    margin-top: 300px;
  }

  to {
    left: 0;
    margin-top: 480px;
  }
}

@keyframes boxOff3 {
  from {
    left: 0;
    margin-top: 480px;
  }

  to {
    left: 550px;
    margin-top: 300px;
  }
}

@keyframes boxOn4 {
  from {
    right: 550px;
    margin-top: 300px;
  }

  to {
    right: 0;
    margin-top: 80px;
  }
}

@keyframes boxOff4 {
  from {
    right: 0;
    margin-top: 80px;
  }

  to {
    right: 550px;
    margin-top: 300px;
  }
}

@keyframes boxOn5 {
  from {
    right: 550px;
    margin-top: 300px;
  }

  to {
    right: 51px;
    margin-top: 280px;
  }
}

@keyframes boxOff5 {
  from {
    right: 51px;
    margin-top: 280px;
  }

  to {
    right: 550px;
    margin-top: 300px;
  }
}

@keyframes boxOn6 {
  from {
    right: 550px;
    margin-top: 300px;
  }

  to {
    right: 0;
    margin-top: 480px;
  }
}

@keyframes boxOff6 {
  from {
    right: 0;
    margin-top: 480px;
  }

  to {
    right: 550px;
    margin-top: 300px;
  }
}

@keyframes boxJump1 {
  0%,
  100% {
    margin-top: 80px;
  }

  50% {
    margin-top: 85px;
  }
}

@keyframes boxJump2 {
  0%,
  100% {
    margin-top: 280px;
  }

  50% {
    margin-top: 275px;
  }
}

@keyframes boxJump3 {
  0%,
  100% {
    margin-top: 480px;
  }

  50% {
    margin-top: 485px;
  }
}

@keyframes boxJump4 {
  0%,
  100% {
    margin-top: 80px;
  }

  50% {
    margin-top: 75px;
  }
}

@keyframes boxJump5 {
  0%,
  100% {
    margin-top: 280px;
  }

  50% {
    margin-top: 285px;
  }
}

@keyframes boxJump6 {
  0%,
  100% {
    margin-top: 480px;
  }

  50% {
    margin-top: 475px;
  }
}
</style>
